import { StatementPayload } from '@/app/tracking/xapi/tincan/client';

export interface CoursePassedFailedStatementParams {
  id: string;
  // title: string;
  // description?: string;
}

export function createCoursePassedFailedStatement(params: CoursePassedFailedStatementParams,
                                                  result: 'passed' | 'failed') {

  const statement: StatementPayload = {
    verb: {
      id: result === 'passed' ? 'http://adlnet.gov/expapi/verbs/passed' :
            'http://adlnet.gov/expapi/verbs/failed',
      display: {
        'en-US': result === 'passed' ? 'passed' : 'failed'
      }
    },
    object: {
      objectType: 'Activity',
      id: params.id,
      definition: {
        type: 'http://adlnet.gov/expapi/activities/course'
        // name: createLangString(params.title),
        // description: params.description ? createLangString(params.description) : undefined
      }
    }
  };

  return statement;
}
